import { useEffect } from 'react';
import { ERROR_MESSAGES } from '../../utils/messages';
import { useMessageModal } from '../../hooks/modal.hook';

function StorageEventHandler({ children }: React.PropsWithChildren) {
  const openMessageModal = useMessageModal();

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'token') {
        openMessageModal(ERROR_MESSAGES.SESSION_ERROR);
      }
    };

    window.addEventListener('storage', handleStorageChange); // Open modal in all tabs

    return () => window.removeEventListener('storage', handleStorageChange);
  }, [openMessageModal]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
}

export default StorageEventHandler;
